<template>
    <div class="offerList ben-fff-bg">
        <div class="title ben-border-t">
            <span class="ben-000-color ben-size-15 ben-text-bold">报价单</span>
        </div>
        <div class="offer-list">
            <div class="comm" v-for="(con,index) in list" :key="index">
                 <van-row class="comm-top ben-border-t">
                    <van-col span="18" class="mas-l ben-text-bold ben-000-color ben-size-14 ben-ell-1">{{con.goods_name}}</van-col>
                    <van-col span="6" class="mas-r ben-size-12 ben-align-right"> 
                        <span v-if="con.tails&&con.tails.wantOfferDetail" class="ben-80c-color">已报价</span>
                        <span v-else class="ben-be-color">未报价</span>
                    </van-col>
                    <van-col span="9" class="mas-num ben-80-color ben-size-12"> 数量: {{con.buy_num}} {{con.unit}} </van-col>
                </van-row>
                <van-row class="comm-botton">
                    <van-col span="18" class="ben-000-color ben-size-14 ben-ell-1">
                        <span class="ben-80-color ben-size-12">产品报价 : </span>
                        <span v-if="con.tails&&con.tails.wantOfferDetail" class="ben-c41335-color ben-size-14 ben-text-bold">
                            ￥{{utils.num_format(con.tails.wantOfferDetail.offer_unit_price/100*con.buy_num)}}
                        </span>
                        <span v-else class="ben-000-color ben-size-12">未填写</span>
                    </van-col>
                    <van-col span="6" class="mas-r ben-be-color ben-size-12 ben-align-right"> 
                        <van-row type="flex" justify="end">
                            <van-col span="10">
                                <p class="comm-edit" @click="editCom(con)"><van-icon name="edit" /></p>
                            </van-col>
                        </van-row>
                    </van-col>
                </van-row>
            </div>
            <!-- 加载更多 -->
            <div class="load-more ben-align-center ben-c41335-color" v-if="list.length<allList.length" @click="loadMore">
                <div class="mohu"></div>
                <p class="ben-size-12">点击查看更多</p>
                <p><van-icon name="arrow-down"  class="ben-text-bold"/></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'offerList',
    props : {
        data : {
            type : Object
        }
    },
    data () {
        return {
            list : [],
            allList  : [],
            pageNum : 1,
            num : 20
        }
    },
    methods: {
        editCom(com){
            this.$emit("oneEdit",com)
            
        },
        loadMore(){
            this.pageNum+=1;
            this.list = this.list.concat(this.allList.slice((this.pageNum-1)*20,this.pageNum*20))
        }
    },
    watch : {
        data(val,oldVal){
            this.allList = val.wantBuyAndDetails.details;
            this.list = []
            this.list = this.list.concat(this.allList.slice((this.pageNum-1)*20,this.pageNum*20))
        }
    },
    mounted () {
        this.allList = this.data.wantBuyAndDetails.details;
        this.list = this.list.concat(this.allList.slice(0,20))
    },
}

</script>


<style lang='scss' scoped>
.offerList{
    margin-top: 5px;
    border-bottom: 5px solid #EEEEEE;
    .load-more{
            position: absolute;
            bottom: 0px;
            left: 0;
            right: 0;
            margin: auto;
            p{
                background: #fff;
            }
            .mohu{
                position: relative;
                height: 40px;
                background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0.24) 69%);
            }
        }
    .van-cell{
        padding: 0;
    }
    .offer-list{
        margin:0 15px ;
        padding: 15px 0;
        position: relative;
        .comm{
            background: #F9F9F9;
            border: 1px solid #EEEEEE;
            border-radius: 4px;
            margin-top: 10px;
            .comm-botton{
                height: 35px;
                line-height: 35px;
                padding-left: 10px;
                .comm-edit{
                    width: 35px;
                    height: 35px;
                    background: #C41335;
                    border-radius: 0px 0px 5px 0px;
                    text-align: center;
                    color: #ffffff;
                    font-size: 12px;
                }
            }
            .comm-top{
                padding: 10px;
            }
        }
    }
    .title{
        padding: 20px 15px 10px 15px;
        border-bottom: 3px solid #eee;
        >span{
            border-bottom: 3px solid #C41335;
            padding-bottom: 10px;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerList.vue